import {Checkbox, FormControl} from '@primer/react'
import {useMergeControlActions, useMergeControlState} from './merge-control-context'

type BypassToggleProps = {
  className?: string
}

export function BypassToggle({className}: BypassToggleProps) {
  const {isAdminBypassToggleChecked, isBypassAllowed, isConfirmingMergeInfo} = useMergeControlState()
  const onToggleAdminBypass = useMergeControlActions()

  if (!isBypassAllowed || isConfirmingMergeInfo) return null

  return (
    <div className={className}>
      <FormControl>
        <Checkbox onChange={onToggleAdminBypass} checked={isAdminBypassToggleChecked} />
        <FormControl.Label>
          <span className="fgColor-danger"> Merge without waiting for requirements to be met (bypass rules) </span>
        </FormControl.Label>
      </FormControl>
    </div>
  )
}
